import { useQuery } from '@tanstack/react-query';
import type { GetWidgetHistoryResponse } from 'server';
import { appFetch } from './appFetch';
import { widgetKeys } from './keys';

export const useGetHistory = (organizationId: string, userToken: string | null) => {
  return useQuery({
    queryKey: widgetKeys.history(organizationId, userToken),
    queryFn: async (): Promise<GetWidgetHistoryResponse> => {
      const response = await appFetch<GetWidgetHistoryResponse>(
        `/app/public/widget/history?organizationId=${organizationId}`,
        {
          method: 'GET',
          userToken
        }
      );
      return response;
    },
    enabled: !!organizationId
  });
};
